import _ from "lodash";
import {__} from "./__";

export const getAiModels = (models) => _.reduce(models, (result, model) => {
    let modelText = model;

    switch (model) {
        case 'gpt-4.1-nano':
            modelText = `${model} - ${__('Jednoduché generovania textov, preklady - nízka cena')}`;
            break;

        case 'gpt-4.1-mini':
            modelText = `${model} - ${__('Zlatá stredná cesta')}`;
            break;

        case 'gpt-4.1':
            modelText = `${model} - ${__('Komplexnejšie úlohy - vyššia cena')}`;
            break;
    }

    return { ...result, [model]: modelText };
}, {});
